import type { InjectionKey, Ref } from '@vue/composition-api';
import { AdminDetailsFragment } from '@/graphql/fragments';

export const AUTH_USER: InjectionKey<Ref<AdminDetailsFragment>> = Symbol('auth.user');

export const AUTH_IS_LOGGED_IN: InjectionKey<Ref<boolean>> = Symbol('auth.isLoggedIn');
